var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 247,
    viewBox: "0 0 104 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.732 104.609c3.761 0 6.81-2.037 6.81-4.55s-3.049-4.55-6.81-4.55c-3.76 0-6.81 2.037-6.81 4.55s3.05 4.55 6.81 4.55z",
    fill: "#EDE9E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.712 109.589c-6.63 0-11.81-4.19-11.81-9.54 0-5.35 5.18-9.55 11.81-9.55 6.63 0 11.8 4.19 11.8 9.55s-5.15 9.54-11.8 9.54z",
    fill: "#F4F2F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.652 241.709a1.005 1.005 0 0 1-.89-.54c-3.15-6.06-8.35-10.41-13.87-15a89.693 89.693 0 0 1-9.87-9.14c-7.83-8.89-12.13-21.42-11.79-34.37.3-11.6 4.18-23.63 11.21-34.78 1.6-2.54 3.37-5 5.07-7.45a101.414 101.414 0 0 0 7.87-12.33c2.36-4.64 5.83-13.68 2.6-22.1a1.001 1.001 0 0 1 .57-1.29.99.99 0 0 1 .766.023.995.995 0 0 1 .524.557c3.52 9.14-.17 18.78-2.68 23.71a103.392 103.392 0 0 1-8 12.59c-1.68 2.39-3.43 4.86-5 7.36-6.84 10.85-10.61 22.52-10.9 33.76-.33 12.45 3.79 24.48 11.29 33a87.069 87.069 0 0 0 9.66 8.93c5.42 4.53 11 9.22 14.35 15.64a1 1 0 0 1-.42 1.35 1.11 1.11 0 0 1-.49.08z",
    fill: "#0B0B0B",
    stroke: "#F4F2F0",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.652 241.709a1.005 1.005 0 0 1-.89-.54c-3.15-6.06-8.35-10.41-13.87-15a89.693 89.693 0 0 1-9.87-9.14c-7.83-8.89-12.13-21.42-11.79-34.37.3-11.6 4.18-23.63 11.21-34.78 1.6-2.54 3.37-5 5.07-7.45a101.414 101.414 0 0 0 7.87-12.33c2.36-4.64 5.83-13.68 2.6-22.1a1.001 1.001 0 0 1 .57-1.29.99.99 0 0 1 .766.023.995.995 0 0 1 .524.557c3.52 9.14-.17 18.78-2.68 23.71a103.392 103.392 0 0 1-8 12.59c-1.68 2.39-3.43 4.86-5 7.36-6.84 10.85-10.61 22.52-10.9 33.76-.33 12.45 3.79 24.48 11.29 33a87.069 87.069 0 0 0 9.66 8.93c5.42 4.53 11 9.22 14.35 15.64a1 1 0 0 1-.42 1.35 1.11 1.11 0 0 1-.49.08z",
    fill: "#0B0B0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.342 102.989a51.35 51.35 0 1 1 51.35-51.35 51.41 51.41 0 0 1-51.35 51.35z",
    fill: "#F4F2F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.732 104.609c3.761 0 6.81-2.037 6.81-4.55s-3.049-4.55-6.81-4.55c-3.76 0-6.81 2.037-6.81 4.55s3.05 4.55 6.81 4.55z",
    fill: "#F4F2F0",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.342 10.299a41.35 41.35 0 1 0 41.35 41.34 41.39 41.39 0 0 0-41.35-41.34z",
    fill: "#EDE9E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.342 97.979c25.593 0 46.34-20.747 46.34-46.34 0-25.593-20.747-46.34-46.34-46.34-25.593 0-46.34 20.747-46.34 46.34 0 25.593 20.747 46.34 46.34 46.34z",
    fill: "#F4F2F0",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.485 80.535c-11.998-.238-20.25-6.877-23.784-12.518",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.778 80.521c11.645.231 19.908-6.08 23.554-11.579",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.24 67.484c1.25 1.374 2.955 2.396 4.89 2.931M24.14 69.364a10.146 10.146 0 0 0 5.723-3.43",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.629 30.837c-.558-4.092-3.79-5.567-6.583-2.983-2.447 2.306-4.323 5.343-5.428 8.789a2.19 2.19 0 0 0 .008.758c.047.249.137.484.265.69.48.733.993 1.435 1.539 2.102.456.624.24 1.019-.367 1.251l-.205.04c-2.896.99-2.503.086-2.278 3.827a37.03 37.03 0 0 0 1.2 6.988c.365 1.178.986 2.221 1.8 3.03 1.816 1.928 4.335 1.284 5.49-1.276.976-2.153 1.124-4.497 1.063-6.876-.031-1.135-.068-2.27-.083-3.403-.035-1.878.42-3.728 1.304-5.3a20.928 20.928 0 0 0 1.675-3.482c.366-1.33.639-2.472.639-3.972l-.04-.183zM48.14 28.423c-.558-4.092-3.79-5.567-6.582-2.983-2.448 2.306-4.323 5.343-5.429 8.788-.041.252-.038.51.009.758.047.25.137.484.264.69.48.734.993 1.436 1.539 2.103.456.623.241 1.019-.367 1.251l-.204.04c-2.897.99-2.504.086-2.279 3.827a37.03 37.03 0 0 0 1.2 6.988c.366 1.177.986 2.221 1.8 3.029 1.816 1.928 4.335 1.284 5.491-1.276.975-2.152 1.123-4.496 1.062-6.875-.031-1.136-.068-2.27-.082-3.403-.035-1.878.42-3.728 1.303-5.301a20.913 20.913 0 0 0 1.675-3.482c.366-1.328.413-2.684.628-4.057l-.028-.097z",
    fill: "#1E1E1E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.168,
    cy: 59.02,
    r: 1,
    fill: "#1E1E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.168,
    cy: 61.02,
    r: 1,
    fill: "#1E1E1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.168,
    cy: 60.02,
    r: 1,
    fill: "#1E1E1E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.168,
    cy: 62.02,
    r: 1,
    fill: "#1E1E1E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.168,
    cy: 63.02,
    r: 1,
    fill: "#1E1E1E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.168,
    cy: 65.02,
    r: 1,
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloon);
export default __webpack_public_path__ + "static/media/baloon.b62897c4401241661e3886e2c349f077.svg";
export { ForwardRef as ReactComponent };